import axios from '../../axios';
import { toast } from 'react-toastify';
import { ADD_COLOR, DELETE_COLOR, GET_COLOR, UPDATE_COLOR, GET_ONE_COLOR, MULTI_DELETE_COLOR } from '../types';

export const getColor = (params) => async (dispatch) => {
   try {
      const res = await axios.get('/color/all', { params });

      if (res.data.code === 1) {
         dispatch({
            type: GET_COLOR,
            payload: {
               data: res.data.data || [],
               pagination: res.data.pagination || {},
               totalCount: res.data.totalCount || 0,
            },
         });
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // console.error("Failed to get Color. Please try again.", err);
   }
};

export const addColor = (formData) => async (dispatch) => {
   try {
      const res = await axios.post('/color/add', formData);
      if (res.data.code === 0) {
         setTimeout(() => {
            toast.error(res.data.message);
         }, 1000);
      }
      if (res.data.code === 1) {
         dispatch({ type: ADD_COLOR, payload: res.data.data });
         setTimeout(() => {
            toast.success('Color added successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data)
         if (err.response && err.response.data && err.response.data.code === 1) {
            return;
         }
      const errorMessage = err.response?.data?.errors?.[0]?.message;
      toast.error(errorMessage || 'An error occurred. Please try again.');
      // if (err.response.data.errors[0].message) {
      //    toast.error(err.response.data.errors[0].message);
      // }
   }
};

export const updateColor = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/color/update`, formData);

      if (res.data.code === 1) {
         dispatch({ type: UPDATE_COLOR, payload: res.data.data });

         setTimeout(() => {
            toast.success('Color updated successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
   }
};

// Delete Color
export const deleteColor = (id, companyId) => async (dispatch) => {
   try {
      if (!id) {
         toast.error('Please select any record');
         return false;
      }
      const res = await axios.post(`/color/delete/${id}/${companyId}`);
      if (res.data.code === 1) {
         dispatch({ type: DELETE_COLOR, payload: { id } });
         setTimeout(() => {
            toast.success('Color deleted successfully!');
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error("Failed to delete color. Please try again.");
   }
};

export const multiDeleteColor = (formData) => async (dispatch) => {
   try {
      const res = await axios.post(`/color/delete/multi`, formData);

      if (res.data.code === 1) {
         dispatch({ type: MULTI_DELETE_COLOR, payload: res.data.data });

         setTimeout(() => {
            toast.success(res.data.message);
         }, 1000);
      }
      if (res.data.code === 2) {
         setTimeout(() => {
            toast.warn(res.data.message);
         }, 1000);
      }
   } catch (err) {
      if (err.response.status === 400) {
         toast.error(err.response.data.message);
         return;
      }
      if (err.response.data.errors[0].message) {
         toast.error(err.response.data.errors[0].message);
      }
      // toast.error('Failed to update customer. Please try again.');
   }
};

export const getSingleColor = (id) => async (dispatch) => {
   try {
      const res = await axios.get(`/color/${id}`);
      if (res.data.code === 1) {
         dispatch({ type: GET_ONE_COLOR, payload: res.data.data });
      }
   } catch (err) {
      console.error('Failed to get item by finish item. Please try again.');
      if (err.response.data.message) {
         toast.error(err.response.data.message);
      }
   }
};
